<!--
  - Copyright (c) 2021 by Leyton Group - All Rights Reserved.
  -  This source code, and resulting software, is the confidential and proprietary information
  -  ("Proprietary Information") and is the intellectual property ("Intellectual Property")
  -  of Leyton Group, Inc. ("The Company"). You shall not disclose such Proprietary Information
  -  and shall use it only in accordance with the terms and conditions of any and all license
  -  agreements you have entered into with The Company.
  -->

<template>
  <div :class="{ 'file-upload': actionType === 'edit' }">
    <span class="totalSelected_files"
      >{{ documents.length }} documents sélectionnés</span
    >
    <div class="giga-actions_dropdown_field">
      <label>Choisir le type de document:</label>
      <div class="giga-actions_dropdown_select">
        <multiselect
          v-select-overflow
          open-direction="bottom"
          :searchable="false"
          :closeOnSelect="false"
          :options="getDocumentsTypes"
          :placeholder="$t('type_document')"
          :multiple="false"
          trackBy="code"
          label="name"
          :showLabels="false"
          class="tags-outline"
          :isRequired="true"
          :is-doc-type="true"
          v-model="values"
          :errorMsg="$t('required_field')"
        >
          <template slot="caret">
            <div
              class="
                multiselect__select
                d-flex
                align-items-center
                justify-content-center
              "
            >
              <b-icon icon="chevron-down"></b-icon>
            </div>
          </template>
          <template slot="option" slot-scope="props">
            <div class="option__desc d-flex justify-content-between">
              <span class="option__title">{{ $t(props.option.name) }}</span>
              <span class="option__info-icon right" :desc="props.option.info">
                <b-icon class="text-muted" icon="info-circle"></b-icon>
              </span>
            </div>
          </template>
        </multiselect>
        <div class="giga-button">
          <button
            :disabled="isDisabled"
            @click="editDocumentType"
            class="giga-green_button no-icon"
          >
            <span> {{ $t("save") }} </span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { map } from "lodash";
import eventBus from "@/shared/event.bus";

export default {
  name: "EditDropDownDocsType",
  props: {
    documents: {
      type: Array,
      default: () => []
    },
    actionType: {
      type: String,
      default: "add"
    }
  },
  data() {
    return {
      values: null
    };
  },
  mounted() {
    this.getDocumentsTypesAction();
  },
  methods: {
    ...mapActions("document", [
      "getDocumentsTypesAction",
      "editDocumentTypesAction"
    ]),
    editDocumentType() {
      const editedDocs = [];
      this.documents.forEach(document => {
        editedDocs.push({ id: document.id, types: [this.values.code] });
      });
      this.$root.$emit("bv::hide::modal", "EditDocumentTypes");
      this.editDocumentTypesAction({ documents: editedDocs });
      eventBus.$emit("reloadDocuments", null);
    }
  },
  computed: {
    ...mapGetters("document", ["getDocumentsTypes"]),
    isDisabled() {
      let flag = false;
      if (this.documents && this.documents.length) {
        this.documents.forEach(document => {
          if (!document.types || document.types < 1) {
            flag = true;
          }
        });
      }
      return flag;
    }
  }
};
</script>
<style lang="scss">
.documents-scroll-area {
  max-height: 340px;
}
</style>
